const schema = {
  type: 'Object',
  contents: {
    key: {
      // no white space between parts
      label: '商品型號',
      type: 'String',
      unique: true,
      required: true,
      disabled: true,
    },
    formattedKey: {
      label: '顯示型號',
      type: 'String',
      unique: true,
      required: true,
    },
    keyOfSupplierSide: {
      label: '供應端商品碼',
      unique: true,
      type: 'String',
    },
    name: {
      label: '商品名稱',
      type: 'String',
      unique: true,
      required: true,
    },
    pdtSerieRef: {
      label: '系列',
      type: 'ObjectId',
      required: true,
      reference: 'pdtSeries',
      refKeys: ['key'], // TODO add code?
    },
    pdtTypeRef: {
      label: '類別',
      type: 'ObjectId',
      required: true,
      reference: 'pdtTypes',
      refKeys: ['key'], // TODO add code?
    },
    supplierRef: {
      label: '供應商',
      type: 'ObjectId',
      reference: 'suppliers',
      refKeys: ['key', 'code'],
    },
    circulationLevel: {
      label: '流通等級',
      type: 'String',
      // required: true,
      options: ['A', 'B', 'C', 'D'],
    },
    weightRatio: {
      label: '運費分攤比',
      type: 'Number',
    },
    description: {
      label: '商品簡介',
      type: 'String',
      input: 'textarea',
    },
    '@suspended': {
      type: 'Boolean',
      label: '停用',
    },
  },
}

export default schema
